import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { useFragment } from "react-relay";

import { Box } from "@whoosh/design-system/src/components/primitive";

import { currentProfileAtom } from "../../../../features/Club/atoms";
import { EventDetailJoinEvent } from "./EventDetailJoinEvent";
import { EventDetailJoinEventSmall_event$key } from "./__generated__/EventDetailJoinEventSmall_event.graphql";

type EventDetailJoinEventSmallProps = {
  fragmentRef: EventDetailJoinEventSmall_event$key;
};

export const EventDetailJoinEventSmall = ({
  fragmentRef,
}: EventDetailJoinEventSmallProps) => {
  const data = useFragment(
    EventDetailJoinEventSmallFragmentString,
    fragmentRef
  );

  const currentProfile = useAtomValue(currentProfileAtom);

  const hasSignup =
    ["CHECKED_IN", "CONFIRMED", "WAITLIST"].includes(
      data?.signUpStatusForClient ?? ""
    ) ||
    (data.memberSignUpProxyAllowed &&
      data.signUps?.edges?.find(
        (e) => e?.node?.ownerClient?.id === currentProfile?.memberId
      ));

  return hasSignup ? null : (
    <Box
      p={{ base: 6, lg: 0 }}
      visible={{ xs: true, lg: false }}
      borderTopLeftRadius={{ base: "6", lg: "0" }}
      borderTopRightRadius={{ base: "6", lg: "0" }}
      bg="surface-primary"
      borderColor="grayscale-1000"
      elevation={12}
      shadowColor={"grayscale-1000"}
      shadowOpacity={0.08}
      shadowOffset={{ width: 0, height: 2 }}
    >
      <EventDetailJoinEvent eventRef={data} />
    </Box>
  );
};

const EventDetailJoinEventSmallFragmentString = graphql`
  fragment EventDetailJoinEventSmall_event on Event {
    signUpStatusForClient(clientId: $memberId)
    signUps {
      edges {
        node {
          id
          ownerClient {
            ... on Member {
              id
            }
            ... on Customer {
              id
            }
          }
        }
      }
    }
    memberSignUpProxyAllowed
    ...EventDetailJoinEvent_event
  }
`;
